import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'admin/hooks'

import { lastSunday, lastSaturday } from 'admin/utils/helper'
import InvoiceItemDataGrid from './datagrid'
import InvoiceItemInfo from '../info'

const Listing = () => {
  const { invoiceItemStore, infoSectionStore } = useStores()

  const urlParams = useMemo(() => {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)
    const barcodeFromURL = searchParams.get('barcode')
    return { barcodeFromURL }
  }, [])

  useEffect(() => {
    const { barcodeFromURL } = urlParams
    if (barcodeFromURL) {
      invoiceItemStore.updateStartDate(null)
      invoiceItemStore.updateEndDate(null)
      invoiceItemStore.updateQuery('barcode', barcodeFromURL, true)
    } else {
      // default range (last Sunday – last Saturday)
      invoiceItemStore.updateStartDate(lastSunday)
      invoiceItemStore.updateEndDate(lastSaturday)
    }
  }, [urlParams])

  useEffect(() => {
    invoiceItemStore.fetch()
  }, [invoiceItemStore.queryParams])

  useEffect(() => {
    const { barcodeFromURL } = urlParams
    if (!barcodeFromURL) return

    const result = invoiceItemStore.list.find(
      (item) => String(item.barcode) === String(barcodeFromURL),
    )
    if (result) {
      infoSectionStore.replace(result)
    }
  }, [invoiceItemStore.list, urlParams])

  return (
    <>
      <InvoiceItemDataGrid />
      <InvoiceItemInfo />
    </>
  )
}

export default observer(Listing)
